import type { SelectedTimePeriod } from "schemas/utils/analytics";

export const AOV_BRACKETS = {
  LOW: { min: 0, max: 50, label: "0-50" },
  MEDIUM: { min: 50, max: 100, label: "50-100" },
  HIGH: { min: 100, max: Number.MAX_SAFE_INTEGER, label: "100+" },
} as const;

/**
 * Given an AOV, return the bracket it belongs to.
 *
 * @author Max 2025-06-20
 */
export function getAovBracket(aov: number): string {
  if (aov < AOV_BRACKETS.MEDIUM.min) {
    return AOV_BRACKETS.LOW.label;
  } else if (aov < AOV_BRACKETS.HIGH.min) {
    return AOV_BRACKETS.MEDIUM.label;
  } else {
    return AOV_BRACKETS.HIGH.label;
  }
}

/**
 * This is the key that will be returned in the final benchmarks object. We calculate
 * benchmarks based on the insutry & AOV bracket.
 *
 * @author Max 2025-06-20
 */
export function createCompositeKey(
  industry: string,
  aovBracket: string,
): string {
  return `${industry}:${aovBracket}`;
}

export const BENCHMARKS_TIMEFRAME: SelectedTimePeriod = {
  type: "relative",
  value: "last-30-days",
};
